var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avater-container"},[_c('img',{staticClass:"avatar-img",style:({
		width: _vm.size+'px',
		height: _vm.size+'px'
	}),attrs:{"src":_vm.url,"alt":"","srcset":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }